enum ActionType {
  message = 'message',
  event = 'event',
  url = 'url',
  internal = 'internal'
}

enum AnimationSize {
  small,
  medium,
  large
}

/**
 * @deprecated AvailableViews is deprecated without replacement since version 2.2.0 and the new menu system
 */
enum AvailableViews {
  home = 1,
  news,
  weather,
  emergency
}

/**
 * @deprecated AvailableSubViews is deprecated without replacement since version 2.2.0 and the new menu system
 */
enum AvailableSubViews {
  history = 1000,
  tutorial
}

enum CategoryId {
  eat = 'where to eat',
  sleep = 'where to sleep',
  see = 'what to see',
  do = 'what to do',
  localproducts = 'local products',
  services = 'services',
  agenda = 'events',
  occupant = 'occupant'
}

enum CloseButtonCause {
  none = 'None',
  detailedpoi = 'Detailed',
  list = 'List',
  history = 'History',
  languages = 'Languages',
  weather = 'Weather',
  emergency = 'Emergency',
  map = 'Map',
  dashboard = 'Dashboard',
  fullscreenimage = 'FullscreenImage',
  news = 'News'
}

enum ContainerParent {
  agent = 1,
  widget,
  news
}

enum CurrentSubView {
  none = 1,
  history,
  languages,
  weather,
  emergency,
  custom
}

enum Depth {
  background = 1,
  util,
  chatbot,
  ui,
  dropdown,
  overlay,
  menu,
  modal,
  exitwidget
}

enum DeviceType {
  mobile = 1,
  borne,
  landscape,
  widget,
  widgetLandscape,
  widgetBorne
}

enum DisplayDataTypes {
  text,
  attachment
}

enum Displays {
  none,
  normal,
  carousel,
  grid,
  carouselgrid,
  list
}

enum Emotions {
  Regret = 'regret',
  Dislike = 'dislike',
  Distress = 'distress',
  Fear = 'fear',
  Sadness = 'sadness',
  Shame = 'shame',
  Contempt = 'contempt',
  Disgust = 'disgust',
  Guilt = 'guilt',
  Anger = 'anger',
  Frustration = 'frustration',
  Pride = 'pride',
  Love = 'love',
  Relief = 'relief',
  Joy = 'joy',
  Hope = 'hope'
}

enum InputHintBehaviour {
  auto = 'auto',
  always = 'always',
  never = 'never',
  ignore = 'ignore'
}

enum ListStatus {
  available = 1,
  opened,
  closing,
  closed
}

enum LoaderSteps {
  loader = 1,
  locale,
  supported,
  store,
  directline,
  ponyfill,
  agentdata
}

enum Mode {
  vocal = 1,
  text,
  dashboard
}

enum PermissionStatus {
  waiting = 1,
  allowed,
  refused,
  error
}

enum Position {
  top = 1,
  right,
  bottom,
  left
}

enum RetorikEvent {
  DetailViewOpen = 1,
  DetailViewClose = 2,
  SpeechStarted = 3,
  SpeechEnded = 4
}

enum RecognitionState {
  Initializing = 1,
  Listening,
  Closing,
  ForceClosing,
  Closed
}

enum RemoteButtonType {
  home = 1,
  menu,
  language,
  subtitles,
  sound,
  history,
  text,
  close
}

enum Routes {
  Home = 1,
  News
}

enum Source3DEngine {
  avatarsdk = 'avatarsdk',
  avatarsdkbis = 'avatar-sdk',
  avaturn = 'avaturn',
  cc3 = 'cc3',
  cc4 = 'cc4',
  rpm = 'rpm',
  readyplayerme = 'readyplayerme'
}

enum UIPart {
  none = 1,
  agent,
  background,
  remote,
  languages,
  card,
  qroverlay
}

enum TextFrom {
  user = 'user',
  bot = 'bot'
}

enum Theme {
  dark = 'dark',
  light = 'light',
  auto = 'auto'
}

enum TraceType {
  message = 'directlineMessage',
  utteranceStart = 'utteranceStart',
  utteranceEnd = 'utteranceEnd'
}

export {
  ActionType,
  AnimationSize,
  AvailableViews,
  AvailableSubViews,
  CategoryId,
  CloseButtonCause,
  ContainerParent,
  CurrentSubView,
  Depth,
  DeviceType,
  DisplayDataTypes,
  Displays,
  Emotions,
  InputHintBehaviour,
  ListStatus,
  LoaderSteps,
  Mode,
  PermissionStatus,
  Position,
  RetorikEvent,
  RecognitionState,
  RemoteButtonType,
  Routes,
  Source3DEngine,
  TextFrom,
  Theme,
  TraceType,
  UIPart
}
